import { render } from "./Prompt.vue?vue&type=template&id=3d99cedc&scoped=true&ts=true"
import script from "./Prompt.vue?vue&type=script&lang=ts"
export * from "./Prompt.vue?vue&type=script&lang=ts"

import "./Prompt.vue?vue&type=style&index=0&id=3d99cedc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d99cedc"]])

export default __exports__